export const Language = {
  FR: 'fr',
  GB: 'en',
  ES: 'es'
};
  